import { addDoc, collection, deleteDoc, doc, getDoc, query, getDocs, updateDoc, where } from 'firebase/firestore';
import { db } from '../config/firebase';

const brandsCollection = collection(db, "brands");

const brandsService = {

  getAll: async () => {
    try {
      const brandsSnapshot = await getDocs(brandsCollection);
      const brandsList = brandsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return brandsList;
    } catch (error) {
      console.error('Error fetching brands:', error);
      throw error;
    }
  },
  add: async (brandsData) => {
    try {
      const docRef = await addDoc(brandsCollection, brandsData);
      return docRef;
    } catch (error) {
      console.error('Error adding brand:', error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const brandRef = doc(db, 'brands', id);
      await updateDoc(brandRef, data);
    } catch (error) {
      console.error('Error updating brands:', error);
      throw error;
    }
  },

  delete: async (brandId) => {
    try {
      await deleteDoc(doc(db, "brands", brandId));
      return true;
    } catch (error) {
      console.error('Error deleting brand:', error);
      throw error;
    }
  },
  getNameById: async (brandId) => {
    if (!brandId) return null;
    try {
      const brandRef = doc(db, 'brands', brandId);
      const brandSnap = await getDoc(brandRef);

      if (brandSnap.exists()) {
        return brandSnap.data().name;
      }
      else {
        return null;
      }
    }
    catch (error) {
      console.error('Error getting brand name:', error);
      throw error;
    }
  },

  getDevisionBrands: async (devisionId) => {
    try {
      const querySnapshot = await getDocs(
        query(brandsCollection, where("division_id", "==", devisionId))
      );

      const brands = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return brands;
    } catch (error) {
      console.error("Error getting brands:", error);
      throw error;
    }
  },

  getTeamsBrands: async (teamId) => {
    try {
      const querySnapshot = await getDocs(
        query(brandsCollection, where("team_id", "==", teamId))
      );

      const brands = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return brands;
    } catch (error) {
      console.error("Error getting Teams:", error);
      throw error;
    }
  }

};

export default brandsService;
